import React from "react";

const FreelancersPage = () => {
  return <p>Freelancers</p>
};

export default FreelancersPage;
